import React from 'react';
import Button from '@atlaskit/button/standard-button';
import { ff } from '@atlassian/jira-feature-flagging';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { useIntl } from '@atlassian/jira-intl';
import { isDevopsFeatureDisabledInFedRamp } from '@atlassian/jira-software-devops-fedramp-utils/src/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { graphProdURL, graphStgURL } from './constants.tsx';
import { GraphIcon } from './graph-icon/index.tsx';
import messages from './messages.tsx';

function Graph({ from }: { from: string }) {
	const { environment } = useTenantContext();
	const graphURL = `${environment === 'staging' ? graphStgURL : graphProdURL}?ari=${from}`;
	const { formatMessage } = useIntl();

	return (
		<Button
			href={graphURL}
			aria-label={formatMessage(messages.graphButtonLabelNonFinal)}
			target="_blank"
			appearance="subtle"
			iconBefore={<GraphIcon />}
		/>
	);
}

export default componentWithCondition(
	() => !isDevopsFeatureDisabledInFedRamp() && ff('otc.show-me-the-graph'),
	Graph,
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
	() => null as any,
);
